import moment from 'moment-timezone';
import columns from '../../../common/list-table/helpers/columns';
import DATE_FORMATS from '../../../common/list-table/constants/dateFormats';

const { timezone } = process.env;

export const textConditionalPropsForXMLReceived = (state, rowInfo) => {
  let className = '';
  const nowCET = moment().tz(timezone).format(DATE_FORMATS.dateTimeWithSeconds);
  if (rowInfo) {
    if (moment(nowCET).diff(moment(rowInfo.row.lastXmlReceivedCet), 'hours') > 4
      && moment(nowCET).diff(moment(rowInfo.row.lastXmlReceivedCet), 'hours') <= 24) {
      className = 'text-orange';
    } else if ((moment(nowCET).diff(moment(rowInfo.row.lastXmlReceivedCet), 'hours') > 24)) {
      className = 'text-red';
    }
  }
  return {
    className,
  };
};

export const textConditionalPropsForLastDataSync = (state, rowInfo) => {
  let className = '';
  const nowCET = moment().tz(timezone).format(DATE_FORMATS.dateTimeWithSeconds);
  if (rowInfo) {
    if (moment(nowCET).diff(moment(rowInfo.row.lastdatasync), 'hours') > 1
      && moment(nowCET).diff(moment(rowInfo.row.lastdatasync), 'hours') <= 24) {
      className = 'text-orange';
    } else if (moment(nowCET).diff(moment(rowInfo.row.lastdatasync), 'hours') > 24) {
      className = 'text-red';
    }
  }
  return {
    className,
  };
};

export const textConditionalPropsForLastRegistration = (state, rowInfo) => {
  let className = '';
  const nowCET = moment().tz(timezone).format(DATE_FORMATS.dateTimeWithSeconds);
  if (rowInfo) {
    if (moment(nowCET).diff(moment(rowInfo.row.lastRegistrationCet), 'hours') > 8
      && moment(nowCET).diff(moment(rowInfo.row.lastRegistrationCet), 'hours') <= 24) {
      className = 'text-orange';
    } else if (moment(nowCET).diff(moment(rowInfo.row.lastRegistrationCet), 'hours') > 24) {
      className = 'text-red';
    }
  }
  return {
    className,
  };
};

export const textConditionalPropsForLastScheduledFlight = (state, rowInfo) => {
  let className = '';
  const nowCET = moment().tz(timezone).format(DATE_FORMATS.dateTimeWithSeconds);
  if (rowInfo && moment(nowCET).diff(moment(rowInfo.row.lastScheduledFlightListUpdateCet), 'hours') > 24) {
    className = 'text-red';
  }
  return {
    className,
  };
};

export const textConditionalPropsForLastActualFlight = (state, rowInfo) => {
  let className = '';
  const nowCET = moment().tz(timezone).format(DATE_FORMATS.dateTimeWithSeconds);
  if (rowInfo) {
    if (moment(nowCET).diff(moment(rowInfo.row.lastActualFlightInformationUpdateCet), 'minutes') > 30
      && moment(nowCET).diff(moment(rowInfo.row.lastActualFlightInformationUpdateCet), 'minutes') <= 180) {
      className = 'text-orange';
    } else if (moment(nowCET).diff(moment(rowInfo.row.lastActualFlightInformationUpdateCet), 'minutes') > 180) {
      className = 'text-red';
    }
  }
  return {
    className,
  };
};

export const textConditionalPropsForReportedIssue = (state, rowInfo) => {
  let className = '';
  if (rowInfo && (rowInfo.row.issueReported === 'Yes')) {
    className = 'text-red';
  }
  return {
    className,
  };
};

export default (data) => {
  const {
    NotFilteredTextColumn,
    NotFilteredDateTimeColumn,
    NotFilteredBooleanColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new NotFilteredTextColumn('MRD', 'deviceId').withWidth(120),
        new NotFilteredTextColumn('Device Type', 'deviceType').withWidth(100),
        new NotFilteredDateTimeColumn('Last XML received (CET)', 'lastXmlReceivedCet').withWidth(200).withGetProps(textConditionalPropsForXMLReceived),
        new NotFilteredDateTimeColumn('Last data sync (CET)', 'lastdatasync').withWidth(200).withGetProps(textConditionalPropsForLastDataSync),
        new NotFilteredBooleanColumn('Issue reported', 'issueReported').withWidth(100).withGetProps(textConditionalPropsForReportedIssue),
        new NotFilteredDateTimeColumn('Last registrations (CET)', 'lastRegistrationCet').withWidth(200).withGetProps(textConditionalPropsForLastRegistration),
        new NotFilteredDateTimeColumn('Last scheduled flight list update (CET)', 'lastScheduledFlightListUpdateCet').withWidth(200).withGetProps(textConditionalPropsForLastScheduledFlight),
        new NotFilteredDateTimeColumn('Last actual flight information update (CET)', 'lastActualFlightInformationUpdateCet').withWidth(200).withGetProps(textConditionalPropsForLastActualFlight),
      ],
    },
  ];
};
